export class MFAType {
    mfaTypeId: number;
    name: string;
}

export enum MFATypeEnum {
    None = 1,
    TOTP = 2
  }